
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { toast } from '../../../utils/common';

interface iFile {
  status: string;
  name: string;
  size: number;
  percentage: number;
  raw: File;
}

@Component
export default class Upload extends Vue {
  @Prop() visible!: boolean;

  @Emit() cancel() {}
  @Emit() ok() {}

  public fileList!: File[];
  private hasFeedback = false;
  private feedback = '';

  get token(): string {
    return UserModule.token;
  }
  uploadUrl() {
    // return 'http://47.100.187.96:9080/api/v1/omc/machine_import';
    return `${process.env.VUE_APP_BASE_API}/api/v1/omc/machine_import`;
  }

  showSuccess(response: any, file: any, fileList: any) {
    if (response.code === 0) {
      this.feedback = response.data[0];
      // toast(this.feedback, 'info');
      this.hasFeedback = true;
      // this.$emit('ok');
    } else {
      toast('导入失败', 'error');
    }
  }

  showErr(err: any, file: any, fileList: any) {}
  // 文件状态改变时的钩子
  fileChange(file: iFile, fileList: File[]) {}

  submitUpload() {
    (this.$refs.upload as Vue & { submit: Function }).submit();
  }
}
